import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import * as types from "../../constants/actionTypes";
import Typeahead from "../../components/ecosystem/core/typeahead/Typeahead";
import { getCityOrZip, getMatchingTerms, getMatchingInsurance } from "../../api/typeaheadApi";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Button, Divider, Icon, Typography, Card, Modal } from "../ecosystem/";

const USE_CURRENT_LOCATION = 'Current Location';

class FindCareForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            kItems: [],
            keywordLoading: false,
            keywordNoResults: false,
            iItems: [],
            insuranceLoading: false,
            insuranceNoResults: false,
            cItems: [],
            cityZipLoading: false,
            cityZipNoResults: false,
            insInvalid: false,
            cityInvalid: false,
            termsModalOpen: false,
            formOpen: !props.isUrgentCare && this.props.isFormOpen, // Hide the form if its urgent care
            isGeoLocation: true
        };
        this.kTime = 0;
        this.iTime = 0;
        this.cTime = 0;

        this.loadKeywordTypeahead = this.loadKeywordTypeahead.bind(this);
        this.loadInsuranceTypeahead = this.loadInsuranceTypeahead.bind(this);
        this.loadCityZipTypeahead = this.loadCityZipTypeahead.bind(this);
        this.toggleTermsModal = this.toggleTermsModal.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.setCurrentLocationAsCityorZip = this.setCurrentLocationAsCityorZip.bind(this);
        this.onKeywordSelected = this.onKeywordSelected.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.FindCareForm.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.geoLocationError !== undefined && this.props.geoLocationError !== "" && this.props.geoLocationError !== prevProps.geoLocationError) {
            this.setState({ isGeoLocation: this.props.geoLocationError && this.props.isCurrentLocation ? false : true });
        }
        else if (this.props.geoLocationError === "" && this.props.geoLocationError !== prevProps.geoLocationError)
            this.setState({ isGeoLocation: true });
    }

    isACOHaveEligibility(ins) {
        if (ins && this.props.acoAlliance) {
            let acoAlliance = this.props.acoAlliance.split(",");
            let ACOItem = Tools.getACOs().find(a => a.label.toLowerCase() === ins.toLowerCase() && (acoAlliance && acoAlliance.indexOf(a.id) > -1));
            if (ACOItem && ACOItem.label) {
                return true;
            }
        }
        return false;
    }

    loadNetworkCode(model) {
        if (this.props.insurance && this.props.insurance !== null && this.props.insurance !== "") {
            if (this.props.networkCode && this.props.networkCode !== null && this.props.userInsurancePlan &&
                this.props.insurance.toLowerCase() === this.props.userInsurancePlan.toLowerCase()) {
                model.networkCode = this.props.networkCode;
                if (this.props.acoAlliance) model.acoAlliance = this.props.acoAlliance;
            } else {
                if (this.isACOHaveEligibility(this.props.insurance)) {
                    model.acoAlliance = this.props.acoAlliance;
                }
            }
        }
        return model;
    }

    loadKeywordTypeahead(val) {
        this.setState({ kItems: [], keywordLoading: true });
        let dt = new Date();
        const { hasSWHP } = this.props;
        let keywordModel = {
            term: val,
            returnAll: false,
            practiceGroup: hasSWHP ? "SWHP" : ""
        };
        this.loadNetworkCode(keywordModel);
        getMatchingTerms(keywordModel, dt.valueOf())
            .then(json => {
                if (this.kTime < json.timestamp) {
                    this.kTime = json.timestamp;
                    let items = [];
                    let lastCategory = "";
                    json = json.results;
                    if (json) {
                        for (var term in json) {
                            if (json[term].values) {

                                if (json[term].name !== lastCategory) {
                                    lastCategory = json[term].name;
                                    items.push({ id: lastCategory, label: lastCategory, category: lastCategory });
                                }

                                for (var i = 0; i < json[term].values.length; i++) {
                                    var val = json[term].values[i];
                                    items.push({ id: val.searchValue, label: val.searchDisplayName, category: json[term].name, vector: val.searchVector, npi: val.npi ? val.npi : null });
                                }

                                if (json[term].count && json[term].count > json[term].values.length && ["provider", "location"].includes(json[term].values[0].searchVector)) {
                                    const lbl = json[term].count - json[term].values.length;
                                    items.push({ id: `+ more ${items[items.length - 1].vector}`, label: `+ more`, category: json[term].name, vector: items[items.length - 1].vector, loadMore: true });
                                }
                            }
                        }
                    }
                    this.setState({ kItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });

                    if (items && items.length > 0) {
                        this.props.setKeywordList(items);
                    }
                }
            });
    }

    loadInsuranceTypeahead(val) {
        if (this.state.insuranceLoading === false) {
            this.setState({ insuranceLoading: true });
            let dt = new Date();
            let insuranceModel = {
                term: val
            };
            this.loadNetworkCode(insuranceModel);
            getMatchingInsurance(insuranceModel, dt.valueOf())
                .then(json => {
                    if (this.iTime < json.timestamp) {
                        this.iTime = json.timestamp;
                        let items = [];
                        let lastCategory = "";
                        json = json.results;
                        if (json) {
                            for (var term in json) {
                                if (json[term].values) {
                                    for (var i = 0; i < json[term].values.length; i++) {
                                        var val = json[term].values[i];
                                        items.push({ id: val.searchValue, label: val.searchDisplayName, category: json[term].name });
                                    }
                                }
                            }
                        }
                        this.setState({ iItems: items, insuranceLoading: false, insuranceNoResults: !(items.length > 0) });
                    }
                });
        }
    }

    loadCityZipTypeahead(val) {
        //if (this.state.cityZipLoading === false) {
        if (val !== "") {
            this.setState({ cityZipLoading: true }, () => {
                let dt = new Date();
                getCityOrZip({ filter: val }, dt.valueOf())
                    .then(json => {
                        if (this.cTime < json.timestamp) {
                            this.cTime = json.timestamp;
                            let items = [];
                            json = json.results;
                            if (json) {
                                for (var term in json) {
                                    items.push({ id: json[term].zip_city, label: json[term].zip_city });
                                }
                            }
                            this.setState({ cItems: items, cityZipLoading: false, cityZipNoResults: !(items.length > 0) });
                        }
                    });
            });
            //}
            //else {
            //    this.setState({ cityZipLoading: false });
            //}
        }
    }

    submitForm(formValid) {
        if (formValid) {
            this.props.searchProvidersAndLocations();
            this.setState({ formOpen: false });
        }
    }

    toggleTermsModal() {
        this.setState({ termsModalOpen: !this.state.termsModalOpen });
    }

    toggleForm() {
        this.setState({ formOpen: !this.state.formOpen }, () => {
            if (this.props.onFormToggle) {
                this.props.onFormToggle(this.state.formOpen);
            }
        });
    }

    setCurrentLocationAsCityorZip() {
        this.props.getGeoLocation(true);
        this.props.setCityZip(USE_CURRENT_LOCATION);
    }

    onKeywordSelected(val, item) {
        const { setVector, setKeyword, searchProviders, searchLocations, keyword, insurance, cityZip } = this.props;
        const { insInvalid, cityInvalid } = this.state;
        const formValid = ((keyword || insurance || cityZip) && (!insInvalid && !cityInvalid));
        setVector(item.vector);

        if (item.npi) {
            // per Jake (#31290): if the selection is a provider, do not run the search; instead, just route directly to the details page.
            this.props.history.push(`/providers/${item.npi}`);
        }
        else if (item.loadMore) {
            setKeyword(keyword);
            if (formValid) {
                if (item.vector === "provider") {
                    searchProviders({ isClearList: true }, { vectorName: item.vector, keyword: keyword + '*' });
                } else if (item.vector === "location") {
                    searchLocations({ isClearList: true }, { vectorName: item.vector, keyword: keyword + '*' });
                }
            }
            this.setState({ formOpen: !this.state.formOpen });
        }
        else {
            setKeyword(item.label);
            //Bug 35177: Find Care - Type Ahead issue for an “invalid” provider in the search results.
            /* if (item.vector === "provider" && formValid) {
                 searchProviders({ isClearList: true }, { vectorName: item.vector, keyword: item.label });
             }*/
        }
    }

    render() {
        const formValid = ((this.props.keyword || this.props.insurance || this.props.cityZip) &&
            (!this.state.insInvalid && !this.state.cityInvalid));

        let useCurrentLocation = <div className='use-current-loc-dropdown'>Use current location</div>;
        const isCurrentLocation = (!this.props.currentLat || !this.props.currentLong || this.props.currentLat === null || this.props.currentLong === null) ? false : true;
        let cityZip = this.props.cityZip === USE_CURRENT_LOCATION && isCurrentLocation ? USE_CURRENT_LOCATION : (this.props.cityZip === USE_CURRENT_LOCATION && !isCurrentLocation) ? '' : this.props.cityZip;
        const isGeoCurrentLocationDisabled = this.props.cityZip === USE_CURRENT_LOCATION && (cityZip === '');

        const keyword = (this.props.keyword && this.props.keyword.indexOf("*") > 0) ? this.props.keyword.substr(0, this.props.keyword.indexOf("*")) : this.props.keyword;
        
        //If we have HP then insuranceplan will always come from parent comp, but still set default value for input valid term 
        const inputValidTerm = this.props.userInsurancePlan ? this.props.userInsurancePlan : "Baylor Scott & White Health Plan";
        const findCareSearchCard = this.props.searchSucceeded ? "findcare-search-card" : "findcare-search-card findcare-search-box";
        const inputWrapper = (content, className) => <div className={`col find-care-input-wrapper ${className}`}>
            <div className="find-care-tile">
                {content}
            </div>
        </div>;

        return (
            <div className="col-12 find-care-form-container">
                <form className="row find-care-form">
                    <div className={"col-12 " + (this.state.formOpen ? " form-open" : "")}> {/* Toggle class name of form-open */}
                        <div className="row find-care-form__modify-btn">
                            <div className="col-12 form-group">
                                <a className="btn btn-primary" onClick={this.toggleForm}>MODIFY SEARCH</a> {/* Wire button to open form */}
                                <div className="search-form-close-btn" onClick={this.toggleForm}><Icon name="x" color="$color-secondary-a2" /></div> {/* Wire button to close form */}
                            </div>
                        </div>
                        <div className="row find-care-form__fields">
                            <div className="col-12">
                                <Card borderStyle={this.props.searchSucceeded ? 'flat' : 'elevated'} className={"findcare-search-card-container"}>
                                    <div className={"row " + findCareSearchCard}>
                                        {inputWrapper(<>
                                            <Typeahead value={keyword} loading={this.state.keywordLoading}
                                                placeholder={"What care are you looking for?"}
                                                prependIcon={{ name: "search" }}
                                                itemList={this.state.kItems} noResults={this.state.keywordNoResults} autoHighlight={false}
                                                onChange={(e, value) => {
                                                    this.loadKeywordTypeahead(value); this.props.setKeyword(value);
                                                    this.props.setVector("unified");
                                                }}
                                                onSelect={this.onKeywordSelected}
                                                submitForm={() => this.submitForm(formValid)}
                                            />
                                        </>, 'keyword-input-wrapper')}

                                        <Divider orientation="vertical" />
                                        {inputWrapper(<>
                                            <Typeahead value={cityZip} loading={this.state.cityZipLoading}
                                                placeholder={"City or Zip"}
                                                prependIcon={{ name: "location" }}
                                                selectOnBlur
                                                itemList={this.state.cItems} noResults={this.state.cityZipNoResults}
                                                onChange={(e, value) => { this.loadCityZipTypeahead(value); this.props.setCityZip(value); }}
                                                onSelect={(val) => this.props.setCityZip(val)} onClickPreOpen={this.setCurrentLocationAsCityorZip}
                                                isInvalid={(invalid) => this.setState({ cityInvalid: invalid })}
                                                submitForm={() => this.submitForm(formValid)}
                                                inputErrorMsg="Select from the drop down."
                                                validTerm="Current Location"
                                                preOpen={this.state.isGeoLocation ? useCurrentLocation : null}
                                            />
                                            {isGeoCurrentLocationDisabled && this.props.geoLocationError && this.props.isCurrentLocation &&
                                                <div className="geo-location-error-msg">{this.props.geoLocationError}</div>
                                            }
                                        </>, 'location-input-wrapper')}

                                        <Divider orientation="vertical" />
                                        {inputWrapper(<>
                                            <Typeahead value={this.props.insurance} loading={this.state.insuranceLoading}
                                                placeholder={"Insurance"}
                                                prependIcon={{ name: "insurance" }}
                                                selectOnBlur
                                                itemList={this.state.iItems} noResults={this.state.insuranceNoResults} autoHighlight={false}
                                                onChange={(e, value) => { this.loadInsuranceTypeahead(value); this.props.setInsurance(value); }}
                                                onSelect={(val) => this.props.setInsurance(val)}
                                                isInvalid={(invalid) => this.setState({ insInvalid: invalid })}
                                                submitForm={() => this.submitForm(formValid)}
                                                inputErrorMsg="Select from the drop down."
                                                validTerm={inputValidTerm}
                                            />
                                        </>, 'insurance-input-wrapper')}

                                        <div className="col find-care-landing-button">
                                            <Button icon="medical" onClick={() => {
                                                logUI("MBHWeb.UI.FindCareForm.SearchButtonClicked", new Date(), Tools.getURLPath());
                                                this.props.searchProvidersAndLocations();
                                                this.setState({ formOpen: false });
                                            }}>Find Care</Button>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="col-12 terms-provider-sub">
                                <Typography type="meta-01">By searching you agree to these <a className="bsw-link-style" onClick={this.toggleTermsModal}>Terms</a></Typography>
                            </div>
                            {/* <div className="col-12 col-lg-5 form-group">
                                <AutocompleteInput value={keyword} loading={this.state.keywordLoading}
                                    placeholder="Condition, Treatment, Specialty, Doctor or Location" prependIcon="icon-search"
                                    itemList={this.state.kItems} noResults={this.state.keywordNoResults} autoHighlight={false}
                                    onChange={(e, value) => {
                                        this.loadKeywordTypeahead(value); this.props.setKeyword(value);
                                        this.props.setVector("unified");
                                    }}
                                    onSelect={this.onKeywordSelected}  
                                    submitForm={() => this.submitForm(formValid)}
                                />
                            </div> */}
                            {/* <div className="col-12 col-sm-8 col-lg-3 form-group">
                                <AutocompleteInput value={this.props.insurance} loading={this.state.insuranceLoading}
                                    placeholder="Insurance" prependIcon="icon-insurance" selectOnBlur
                                    itemList={this.state.iItems} noResults={this.state.insuranceNoResults} autoHighlight={false}
                                    onChange={(e, value) => { this.loadInsuranceTypeahead(value); this.props.setInsurance(value);}}
                                    onSelect={(val) => this.props.setInsurance(val)}
                                    isInvalid={(invalid) => this.setState({ insInvalid: invalid })}
                                    submitForm={() => this.submitForm(formValid)}
                                    inputErrorMsg="Select from the drop down."
                                    validTerm={inputValidTerm}
                                />
                            </div>                            */}
                            {/* <div className="col-12 col-sm-4 col-lg-2 form-group">
                                <AutocompleteInput value={cityZip} loading={this.state.cityZipLoading}
                                    placeholder="City or Zip" prependIcon="icon-location" selectOnBlur
                                    itemList={this.state.cItems} noResults={this.state.cityZipNoResults}
                                    onChange={(e, value) => { this.loadCityZipTypeahead(value); this.props.setCityZip(value); }}
                                    onSelect={(val) => this.props.setCityZip(val)} onClickPreOpen={this.setCurrentLocationAsCityorZip}
                                    isInvalid={(invalid) => this.setState({ cityInvalid: invalid })}
                                    submitForm={() => this.submitForm(formValid)}
                                    inputErrorMsg="Select from the drop down."
                                    validTerm="Current Location"
                                    preOpen={this.state.isGeoLocation ? useCurrentLocation : null}
                                />           
                                {isGeoCurrentLocationDisabled && this.props.geoLocationError && this.props.isCurrentLocation &&
                                    <div className="geo-location-error-msg">{this.props.geoLocationError}</div>
                                }
                            </div>                            */}
                            {/* <div className="col-12 col-lg-2 form-group">
                                <button type="button" disabled={!formValid} className="btn btn-primary" onClick={() => {
                                        logUI("MBHWeb.UI.FindCareForm.SearchButtonClicked", new Date(), Tools.getURLPath());
                                        this.props.searchProvidersAndLocations();
                                        this.setState({ formOpen: false });
                                    }
                                }
                                ><span>Search</span></button>
                            </div> */}
                            {/* <div className="col-12 form-group terms-provider-sub">By searching you agree to these <a className="link-style" onClick={this.toggleTermsModal}>Terms</a></div> */}
                        </div>
                    </div>
                </form>
                <Modal
                    isOpen={this.state.termsModalOpen}
                    backdrop="static"
                    modalBody="We operate our provider referral service to assist patients in selecting providers who are members of Baylor Scott & White Quality Alliance. There are no charges to the providers or you for this service. Search results reflect all providers meeting the criteria you designate for your search. Your final selection of a provider should be based on your needs and preferences. If a provider leaves Baylor Scott & White Quality Alliance, we will no longer include the provider in our referral service. By using the provider referral service, you certify that you have received these disclosures."
                    modalFooter={<Button onClick={this.toggleTermsModal}>Accept</Button>}
                    toggle={this.toggleTermsModal}
                    onCloseClick={this.toggleTermsModal}
                />
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        searchSucceeded: state.providers.success,
    };
};

export default (connect(mapStateToProps)(FindCareForm));
